module.exports = __webpack_public_path__ + "img/HINDU BW.c8ed699.svg";